import gql from 'graphql-tag';

export const SEARCH_OCCUPATIONS = gql`
  query searchOccupations($searchTerm: String) {
    searchOccupations(searchTerm: $searchTerm)
  }
`;
